@if (isLoading()) {
  <div class="loader-background">
    <div class="loader-container">
      <!--<img class="logo" src="assets/logo/suite_logo_256.png" alt="logo" />-->
      <div class="icons-container">
        <img src="assets/logo/pdf.svg" class="module-icon module-icon-pdf" />
        <div class="module-icon module-icon-map"></div>
        <div class="module-icon module-icon-editor"></div>
      </div>
      @if(progress() >= 0){
        <mat-progress-bar class="progress-bar" buffer="0"
          [mode]="progress() >= 0 && progress() <= 100 ? 'buffer' : 'indeterminate'"
          [value]="progress() >= 0 && progress() <= 100 ? progress() : undefined">
        </mat-progress-bar>
      }
      <div class="message" translate>{{ message() }}</div>
    </div>
  </div>
}